/* global loadJS, LazyLoad */
(function () {
  var classList = document.documentElement.classList;

  function loadLazyLoad() {
    loadJS('/js/lazyload/lazyload.min.js', function () {
      return new LazyLoad({
        elements_selector: '.lazy'
      });
    });
  }

  if (classList.contains('no-promises')) {
    loadJS('/js/polyfills/polyfill.min.js', true);
  }
  /*
  if (classList.contains('no-objectfit')) {
      loadJS('/js/polyfills/objectFitPolyfill.min.js', true)
  }
  */


  if (!('IntersectionObserver' in window) || !('IntersectionObserverEntry' in window) || !('intersectionRatio' in window.IntersectionObserverEntry.prototype)) {
    document.documentElement.classList.add('no-intersectionobserver');
    loadJS('/js/polyfills/intersection-observer.js', loadLazyLoad);
  } else {
    document.documentElement.classList.add('intersectionobserver');
    loadLazyLoad();
  }
  /*
  if (classList.contains('no-fetch')) {
      loadJS('/js/polyfills/fetch.umd.js')
  }
  */

})();
require("core-js/modules/es.array.iterator.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.set.js");

require("core-js/modules/es.string.iterator.js");

require("core-js/modules/web.dom-collections.iterator.js");

require("core-js/modules/es.array.includes.js");

require("core-js/modules/es.string.includes.js");

require("core-js/modules/es.parse-int.js");

require("core-js/modules/es.array.for-each.js");

require("core-js/modules/web.dom-collections.for-each.js");

require("core-js/modules/web.timers.js");

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.string.search.js");

/*! instant.page v5.1.0 - (C) 2019-2020 Alexandre Dieulot - https://instant.page/license */
var mouseoverTimer;
var lastTouchTimestamp;
var prefetches = new Set();
var prefetchElement = document.createElement('link');
var isSupported = prefetchElement.relList && prefetchElement.relList.supports && prefetchElement.relList.supports('prefetch') && window.IntersectionObserver && 'isIntersecting' in IntersectionObserverEntry.prototype;
var allowQueryString = ('instantAllowQueryString' in document.body.dataset);
var allowExternalLinks = ('instantAllowExternalLinks' in document.body.dataset);
var useWhitelist = ('instantWhitelist' in document.body.dataset);
var mousedownShortcut = ('instantMousedownShortcut' in document.body.dataset);
var DELAY_TO_NOT_BE_CONSIDERED_A_TOUCH_INITIATED_ACTION = 1111;
var delayOnHover = 65;
var useMousedown = false;
var useMousedownOnly = false;
var useViewport = false;

if ('instantIntensity' in document.body.dataset) {
  var intensity = document.body.dataset.instantIntensity;

  if (intensity.substr(0, 'mousedown'.length) == 'mousedown') {
    useMousedown = true;

    if (intensity == 'mousedown-only') {
      useMousedownOnly = true;
    }
  } else if (intensity.substr(0, 'viewport'.length) == 'viewport') {
    if (!(navigator.connection && (navigator.connection.saveData || navigator.connection.effectiveType && navigator.connection.effectiveType.includes('2g')))) {
      if (intensity == "viewport") {
        /* Biggest iPhone resolution (which we want): 414 × 896 = 370944
         * Small 7" tablet resolution (which we don’t want): 600 × 1024 = 614400
         * Note that the viewport (which we check here) is smaller than the resolution due to the UI’s chrome */
        if (document.documentElement.clientWidth * document.documentElement.clientHeight < 450000) {
          useViewport = true;
        }
      } else if (intensity == "viewport-all") {
        useViewport = true;
      }
    }
  } else {
    var milliseconds = parseInt(intensity);

    if (!isNaN(milliseconds)) {
      delayOnHover = milliseconds;
    }
  }
}

if (isSupported) {
  var eventListenersOptions = {
    capture: true,
    passive: true
  };

  if (!useMousedownOnly) {
    document.addEventListener('touchstart', touchstartListener, eventListenersOptions);
  }

  if (!useMousedown) {
    document.addEventListener('mouseover', mouseoverListener, eventListenersOptions);
  } else if (!mousedownShortcut) {
    document.addEventListener('mousedown', mousedownListener, eventListenersOptions);
  }

  if (mousedownShortcut) {
    document.addEventListener('mousedown', mousedownShortcutListener, eventListenersOptions);
  }

  if (useViewport) {
    var triggeringFunction;

    if (window.requestIdleCallback) {
      triggeringFunction = function triggeringFunction(callback) {
        requestIdleCallback(callback, {
          timeout: 1500
        });
      };
    } else {
      triggeringFunction = function triggeringFunction(callback) {
        callback();
      };
    }

    triggeringFunction(function () {
      var intersectionObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var linkElement = entry.target;
            intersectionObserver.unobserve(linkElement);
            preload(linkElement.href);
          }
        });
      });
      document.querySelectorAll('a').forEach(function (linkElement) {
        if (isPreloadable(linkElement)) {
          intersectionObserver.observe(linkElement);
        }
      });
    });
  }
}

function touchstartListener(event) {
  /* Chrome on Android calls mouseover before touchcancel so `lastTouchTimestamp`
   * must be assigned on touchstart to be measured on mouseover. */
  lastTouchTimestamp = performance.now();
  var linkElement = event.target.closest('a');

  if (!isPreloadable(linkElement)) {
    return;
  }

  preload(linkElement.href);
}

function mouseoverListener(event) {
  if (performance.now() - lastTouchTimestamp < DELAY_TO_NOT_BE_CONSIDERED_A_TOUCH_INITIATED_ACTION) {
    return;
  }

  var linkElement = event.target.closest('a');

  if (!isPreloadable(linkElement)) {
    return;
  }

  linkElement.addEventListener('mouseout', mouseoutListener, {
    passive: true
  });
  mouseoverTimer = setTimeout(function () {
    preload(linkElement.href);
    mouseoverTimer = undefined;
  }, delayOnHover);
}

function mousedownListener(event) {
  var linkElement = event.target.closest('a');

  if (!isPreloadable(linkElement)) {
    return;
  }

  preload(linkElement.href);
}

function mouseoutListener(event) {
  if (event.relatedTarget && event.target.closest('a') == event.relatedTarget.closest('a')) {
    return;
  }

  if (mouseoverTimer) {
    clearTimeout(mouseoverTimer);
    mouseoverTimer = undefined;
  }
}

function mousedownShortcutListener(event) {
  if (performance.now() - lastTouchTimestamp < DELAY_TO_NOT_BE_CONSIDERED_A_TOUCH_INITIATED_ACTION) {
    return;
  }

  var linkElement = event.target.closest('a');

  if (event.which > 1 || event.metaKey || event.ctrlKey) {
    return;
  }

  if (!linkElement) {
    return;
  }

  linkElement.addEventListener('click', function (event) {
    if (event.detail == 1337) {
      return;
    }

    event.preventDefault();
  }, {
    capture: true,
    passive: false,
    once: true
  });
  var customEvent = new MouseEvent('click', {
    view: window,
    bubbles: true,
    cancelable: false,
    detail: 1337
  });
  linkElement.dispatchEvent(customEvent);
}

function isPreloadable(linkElement) {
  if (!linkElement || !linkElement.href) {
    return;
  }

  if (useWhitelist && !('instant' in linkElement.dataset)) {
    return;
  }

  if (!allowExternalLinks && linkElement.origin != location.origin && !('instant' in linkElement.dataset)) {
    return;
  }

  if (!['http:', 'https:'].includes(linkElement.protocol)) {
    return;
  }

  if (linkElement.protocol == 'http:' && location.protocol == 'https:') {
    return;
  }

  if (!allowQueryString && linkElement.search && !('instant' in linkElement.dataset)) {
    return;
  }

  if (linkElement.hash && linkElement.pathname + linkElement.search == location.pathname + location.search) {
    return;
  }

  if ('noInstant' in linkElement.dataset) {
    return;
  }

  return true;
}

function preload(url) {
  if (prefetches.has(url)) {
    return;
  }

  var prefetcher = document.createElement('link');
  prefetcher.rel = 'prefetch';
  prefetcher.href = url;
  document.head.appendChild(prefetcher);
  prefetches.add(url);
}
require("core-js/modules/es.array.find.js");

/* global $ */

/* global jQuery */

/* global loadJS */
jQuery(function () {
  $.nette.init();
  $('body').on('click', '.confirm', function (event) {
    event.preventDefault();
    event.stopImmediatePropagation();
    var text = $(this).data('confirm-text');

    if (confirm(text ? '' + text : $('html').attr('lang') === 'cs' ? 'Opravdu smazat tento záznam?' : 'Do you really want to delete this record?')) {
      document.location = $(this).attr('href');
    }
  });

  if ($('#ajaxSpinner').length > 0) {
    $(document).on('ajaxStart', function () {
      $('#ajaxSpinner').addClass('loading');
    });
    $(document).on('ajaxStop', function () {
      $('#ajaxSpinner').removeClass('loading');
    });
  }

  $.nette.ext({
    before: function before() {
      $('form.ajax').addClass('loading');
    },
    complete: function complete() {
      $('form.ajax').removeClass('loading');
    }
  }); // DYNAMIC GRECAPTCHA LOADER

  var grecaptchaLoading = false;

  if ($('form .g-recaptcha').length > 0) {
    if (window.grecaptcha === undefined) {
      $('form input').on('focus', function () {
        if (!grecaptchaLoading && window.grecaptcha === undefined) {
          grecaptchaLoading = true;
          loadJS('/js/recaptcha/recaptcha.invisible.ajax.js', function () {
            grecaptchaLoading = false;
          });
        }
      });
    }
  }
});
jQuery(function () {
  $('a.toggle-d-none').on('click', function (event) {
    event.preventDefault();
    event.stopImmediatePropagation();
    $($(this).attr('href')).removeClass('d-none');
  });
});
jQuery(function () {
  if ($('.aks-nav-card').length > 0) {
    $('.aks-nav-card-content a').on('click', function (event) {
      event.stopImmediatePropagation();
    });
    $('.aks-nav-card').on('click', function (event) {
      if (event.target.tagName !== 'A') {
        event.stopImmediatePropagation();
        var linkEl = $(this).find('.aks-nav-card-title a').get(0);

        if (linkEl instanceof Node) {
          console.log(linkEl);
          linkEl.click();
        }
      }
    });
  }
});
/* global toastr */
(function () {
  if (document.readyState === 'loading') {
    window.addEventListener('DOMContentLoaded', function () {
      run();
    });
  } else {
    run();
  }

  function run() {
    document.body.classList.add('site-onready'); // setToastrDefaults()
    // showFlashMessages()
  }
  /*function setToastrDefaults() {
      if (Object.prototype.hasOwnProperty.call(window, 'toastr')) {
          toastr.options = {'closeButton': true, 'progressBar': true}
      }
  }*/

  /*function showFlashMessages() {
      if (
          window._cmsFlashMessages !== undefined &&
          Array.isArray(window._cmsFlashMessages) &&
          window._cmsFlashMessages.length > 0
      ) {
          for (var index in window._cmsFlashMessages) {
              var item = window._cmsFlashMessages[index]
              switch (item.type) {
                  case 'success':
                      toastr.success(item.message)
                      break
                  case 'error':
                      toastr.error(item.message)
                      break
                  case 'warning':
                      toastr.warning(item.message)
                      break
                  default:
                      toastr.info(item.message)
              }
          }
          window._cmsFlashMessages = []
      }
  }*/


  window.dataLayer = window.dataLayer || [];
})();
/* global SmoothScroll */
(function () {
  if (document.readyState === 'loading') {
    window.addEventListener('DOMContentLoaded', function () {
      run();
    });
  } else {
    run();
  }

  function run() {
    if (SmoothScroll !== undefined) {
      /* eslint-disable-next-line no-unused-vars */
      var scroll = new SmoothScroll('a[data-scroll][href*="#"]');
    }
  }
})();
require("core-js/modules/web.timers.js");

(function () {
  if (document.readyState === 'loading') {
    window.addEventListener('DOMContentLoaded', function () {
      run();
    });
  } else {
    run();
  }

  var tm;
  var prevPosition = 0;
  var position = 0;

  function checkStickyMenu() {
    position = window.pageYOffset;
    var body = document.body;
    var isActive = body.classList.contains('sticky-header');

    if (position > 150) {
      if (!isActive) {
        body.classList.add('sticky-header-no-transition');
        setTimeout(function () {
          body.classList.remove('sticky-header-no-transition');
        }, 50);
        body.classList.add('sticky-header');
      }

      if (position - prevPosition < 0 && isActive) {
        body.classList.add('sticky-header-up');
      } else {
        body.classList.remove('sticky-header-up');
      }
    } else {
      body.classList.remove('sticky-header-no-transition');
      body.classList.remove('sticky-header');
      body.classList.remove('sticky-header-up');
    }

    prevPosition = position;
  }

  function run() {
    document.addEventListener('scroll', function (event) {
      clearTimeout(tm);
      tm = setTimeout(checkStickyMenu, 25);
    });
    checkStickyMenu();
  }
})();
require("core-js/modules/es.parse-int.js");

/* global CountUp */
(function () {
  if (document.readyState === 'loading') {
    window.addEventListener('DOMContentLoaded', function () {
      run();
    });
  } else {
    run();
  }

  function run() {
    var elements = document.querySelectorAll('.aks-counter');

    if (window.CountUp !== undefined && elements.length > 0) {
      var observer = new IntersectionObserver(onIntersection, {
        root: null,
        rootMargin: '0px',
        threshold: 0.3
      });

      for (var index in elements) {
        var element = elements[index];

        if (element instanceof Element) {
          var target = element.querySelectorAll('.aks-counter-number')[0];

          if (target) {
            var startValue = parseInt(element.dataset.from);
            var endValue = parseInt(element.dataset.to);
            var separator = element.dataset.separator ? element.dataset.separator : '';
            target.innerText = startValue;
            element._countUpInstance = new CountUp(target, endValue, {
              startVal: startValue,
              separator: separator
            });
            element._countUpProcessed = false;
            observer.observe(element);
          }
        }
      }
    }
  }

  function onIntersection(entries, observer) {
    for (var i in entries) {
      var entry = entries[i];

      if (entry.isIntersecting && !entry.target._countUpProcessed) {
        entry.target._countUpInstance.start();

        entry.target._countUpProcessed = true;
      }
    }
  }
})();
(function () {
  if (document.readyState === 'loading') {
    window.addEventListener('DOMContentLoaded', function () {
      run();
    });
  } else {
    run();
  }

  function run() {
    var elements = document.querySelectorAll('.cta-contact-btn');

    if (elements.length > 0) {
      for (var index in elements) {
        var element = elements[index];

        if (element instanceof Node) {
          var img = document.createElement('img');
          img.setAttribute('src', '/uploads/icons/email-outline-white.svg');
          img.setAttribute('class', 'btn-icon');
          var img2 = document.createElement('img');
          img2.setAttribute('src', '/uploads/icons/phone-white.svg');
          img2.setAttribute('class', 'btn-icon');
          var text = document.createElement('span');
          text.setAttribute('class', 'btn-text');
          text.innerText = element.innerText;
          element.innerText = '';
          element.appendChild(img);
          element.appendChild(img2);
          element.appendChild(text);
        }
      }
    }
  }
})();
jQuery(function () {
  $('body').on('focus change', '.form-group input, .form-group textarea', checkLabels);

  function checkLabels() {
    $('.form-group input, .form-group textarea').each(function (index, element) {
      if (element.value || document.activeElement === element) {
        $(element).parents('.form-group').first().addClass('__floating-label');
      } else {
        $(element).parents('.form-group').first().removeClass('__floating-label');
      }
    });
  }

  $.nette.ext('floatingLabels', {
    success: function success() {
      checkLabels();
    }
  });
  checkLabels();
});
require("core-js/modules/web.timers.js");

require("core-js/modules/es.array.find.js");

/* global jQuery, $ */
jQuery(function () {
  var tm;
  var rTm;
  var mediaQueryMatch = false;
  var mediaQueryList = window.matchMedia('(min-width: 992px)');
  var mobileMenuOpen = false;
  var pTm;

  try {
    mediaQueryList.addEventListener('change', onMediaQueryChange);
  } catch (err) {
    $(window).on('resize', function () {
      clearTimeout(pTm);
      pTm = setTimeout(function () {
        onMediaQueryChange(window.matchMedia('(min-width: 992px)'));
      }, 25);
    });
  }

  onMediaQueryChange(mediaQueryList); // Mobilní toggle

  $('button.dropdown-mobile-toggle').on('click', function (event) {
    event.preventDefault();
    event.stopImmediatePropagation();

    if ($(this).parent().attr('aria-expanded') === 'true') {
      $(this).parent().attr('aria-expanded', 'false').parent().find('.dropdown-menu').first().removeClass('show');
    } else {
      $(this).parent().attr('aria-expanded', 'true').parent().find('.dropdown-menu').first().addClass('show');
    }
  });

  function onMediaQueryChange(queryList) {
    var oldValue = !!mediaQueryMatch;
    mediaQueryMatch = queryList.matches === true;

    if (oldValue !== mediaQueryMatch) {
      resetTimeouts();

      if (oldValue) {
        $('.mega-dropdown-dropdown-toggle').attr('aria-expanded', 'true');
      } else {
        $('.mega-dropdown-dropdown-toggle').attr('aria-expanded', 'false');
      }
    }

    if (mediaQueryMatch) {
      $('html').removeClass('mobile-menu-open');
    } else {
      if (mobileMenuOpen) {
        $('html').addClass('mobile-menu-open');
      }
    }
  }

  $('.navbar-toggler').on('click', function () {
    $('html').toggleClass('mobile-menu-open');
    mobileMenuOpen = $('html').hasClass('mobile-menu-open');
    resetDropdowns();
  });

  function attachListeners() {
    $('.navbar-aks .nav-item.dropdown.position-static > [data-toggle="dropdown"]').on('mouseenter mouseover focus', setDisplayTimeout);
    $('.navbar-aks').on('mouseleave', setResetDropdownsTimeout);
    $('.navbar-aks .dropdown-menu').on('mouseenter', resetTimeouts);
    $('body > .main-content').on('click mouseenter', setResetDropdownsTimeout);
    $('.navbar-aks .top-level-link').on('mouseenter', setResetDropdownsTimeout);
  }

  function resetTimeouts() {
    clearTimeout(tm);
    clearTimeout(rTm);
  }

  function setResetDropdownsTimeout() {
    if (mediaQueryMatch) {
      clearTimeout(rTm);
      rTm = setTimeout(function () {
        resetDropdowns();
      }, 50);
    }
  }

  function resetDropdowns() {
    $('.navbar-aks [data-toggle="dropdown"][aria-expanded="true"]').attr('aria-expanded', 'false');
    $('.navbar-aks .dropdown-menu.show').removeClass('show');
  }

  function setDisplayTimeout(event) {
    if (mediaQueryMatch) {
      if ($('.navbar-aks .dropdown-menu.show').length > 0) {
        tm = setTimeout(function () {
          displayDropdown(event);
        }, 50);
      } else {
        displayDropdown(event);
      }
    }
  }

  function displayDropdown(event) {
    if (mediaQueryMatch) {
      if ($(event.target).attr('aria-expanded') === 'false') {
        resetDropdowns();
        $(event.target).attr('aria-expanded', 'true').parent().find('.dropdown-menu').first().addClass('show');
      }
    }
  }

  attachListeners();
});
jQuery(function () {
  if (typeof $('body').lightGallery === 'function' && $('[data-gallery]').length > 0) {
    $('[data-gallery]').each(function () {
      var wrapper = $(this);
      var options = wrapper.data('gallery') !== '' ? wrapper.data('gallery') : {};
      wrapper.lightGallery(options);
    });
  }
});
require("core-js/modules/es.array.find.js");

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.string.replace.js");

/* global jQuery $ */
jQuery(function () {
  if ($('[data-isotope]').length > 0) {
    $('[data-isotope]').each(function () {
      var _this = $(this);

      _this.__isotopeFilters = {};
      $(this).parent().find('[data-filter]').on('click', function (event) {
        event.preventDefault();

        if ($(this).data('filter') === '*') {
          _this.isotope({
            filter: '*'
          });

          _this.__isotopeFilters = {};

          _this.parent().find('[data-filter-group]').removeClass(_this.data('filter-active-class')).addClass(_this.data('filter-inactive-class'));
        } else {
          _this.__isotopeFilters[$(this).data('filter-group')] = $(this).data('filter');

          _this.parent().find('[data-filter-group="' + $(this).data('filter-group') + '"]').removeClass(_this.data('filter-active-class')).addClass(_this.data('filter-inactive-class'));

          $(this).addClass(_this.data('filter-active-class')).removeClass(_this.data('filter-inactive-class'));
          var filter = '';

          for (var groupId in _this.__isotopeFilters) {
            filter = filter + _this.__isotopeFilters[groupId];
          }

          _this.isotope({
            filter: filter
          });
        }
      });

      _this.isotope({
        filter: '*'
      });
    });
    var filterEl = $('a[data-url-hash="' + window.location.hash.replace('#', '') + '"]');

    if (filterEl.length > 0) {
      filterEl.first().click();

      if ($(window.location.hash).length > 0 && $('#isotopeComponent-referencesIsotope').length > 0) {
        document.getElementById('isotopeComponent-referencesIsotope').scrollIntoView();
      }
    }
  }
});
require("core-js/modules/web.timers.js");

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.string.replace.js");

require("core-js/modules/web.immediate.js");

require("core-js/modules/es.array.filter.js");

(function () {
  if (document.readyState === 'loading') {
    window.addEventListener('DOMContentLoaded', function () {
      run();
    });
  } else {
    run();
  }

  var playerReady = false;
  var activePlayers = [];

  function onYouTubeIframeAPIReady() {
    playerReady = true;
  }

  window.onYouTubeIframeAPIReady = onYouTubeIframeAPIReady;

  function attachHandlers() {
    var buttons = document.querySelectorAll('.__aks-play-button');

    for (var i = 0; i < buttons.length; i++) {
      buttons[i].addEventListener('click', playVideo);
    }
  }

  var tm;

  function playVideo(event) {
    event.preventDefault();

    if (!playerReady) {
      clearTimeout(tm);
      tm = setTimeout(function () {
        playVideo(event);
      }, 1000);
    }

    for (var i = 0; i < activePlayers.length; i++) {
      if (typeof activePlayers[i].stopVideo === 'function') {
        activePlayers[i].stopVideo();
      }
    }

    var players = document.querySelectorAll('.__aks-video-player');

    for (var i = 0; i < players.length; i++) {
      players[i].classList.add('d-none');
    }

    var elementId = event.target.getAttribute('href').replace('#player_wrapper_', '');
    var wrapper = document.getElementById('player_wrapper_' + elementId);

    if (wrapper) {
      wrapper.classList.remove('d-none');
      setImmediate(function () {
        wrapper.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
        setTimeout(function () {
          var player = activePlayers.filter(function (item) {
            return item.__aksId === elementId;
          });

          if (player.length > 0) {
            player = player[0];
          } else {
            player = null;
          }

          if (player) {
            player.playVideo();
          } else {
            player = new YT.Player('player_' + elementId, {
              events: {
                onReady: function onReady(event) {
                  event.target.playVideo();
                  event.target.__aksId = elementId;
                  activePlayers.push(event.target);
                }
              }
            });
          }
        }, 1000);
      });
    }
  }

  function run() {
    var elements = document.querySelectorAll('.__aks-video-player');

    if (elements.length > 0) {
      var tag = document.createElement('script');
      tag.src = 'https://www.youtube.com/iframe_api';
      var firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
      attachHandlers();
    }
  }
})();